import { render } from "./LetsinIndexTable.vue?vue&type=template&id=5bb834b4"
import script from "./LetsinIndexTable.vue?vue&type=script&lang=js"
export * from "./LetsinIndexTable.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__